import { Avatar } from "@mui/material";
import { dashBoardNoti } from "assets/data/dashboard";
import { Link } from "react-router-dom";
import { logo } from "utils/assets_exports/images";
import { shortUserName } from "utils/helpers/shortUserName";
import { CustomComponentProps } from "utils/types/general.types";

export type UpdatedPostProps = CustomComponentProps & {
    noti: dashBoardNoti;
};

const PushNotification = ({ noti, className, style }: UpdatedPostProps) => {
    return (
        <Link
            to={`/notifications/view/${noti.id}`}
            className={`flex justify-between w-full px-4 py-2 items-center gap-3 hover:shadow-lg hover:text-momeento-50 dark:text-white ${className}`}
            style={style}
        >
            <div className="flex justify-start items-center gap-2">
                <Avatar src={logo} sx={{ width: 30, height: 30 }} />
                <div>
                    <h3 className="font-medium">
                        {shortUserName(noti.title, 10)}
                    </h3>
                    <p className="text-sm">{shortUserName(noti.body, 30)}</p>
                    <p className="text-xs">{noti.date}</p>
                </div>
            </div>
            <div
                className="px-1 py-1 text-center text-xs bg-momeento-50 text-white hover:shadow-xl rounded"
                style={{ minWidth: 30 }}
            >
                {noti.count}
            </div>
        </Link>
    );
};

export default PushNotification;
